var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.913rem",
    viewBox: "0 0 30.603 29.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header_Notifications",
    "data-name": "Header Notifications",
    transform: "translate(-1512.32 -43.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.6,27.194a3.719,3.719,0,0,1-3.208-1.848,1.236,1.236,0,0,1,1.069-1.857h4.277a1.237,1.237,0,0,1,1.07,1.857A3.723,3.723,0,0,1,13.6,27.194Zm12.362-6.177H1.236a1.236,1.236,0,0,1,0-2.472,2.476,2.476,0,0,0,2.472-2.473V9.89a9.89,9.89,0,1,1,19.78,0v6.181a2.476,2.476,0,0,0,2.472,2.473A1.185,1.185,0,0,1,27.2,19.78a1.272,1.272,0,0,1-.309.85A1.2,1.2,0,0,1,25.961,21.016ZM13.6,2.472A7.426,7.426,0,0,0,6.181,9.89v6.181a4.948,4.948,0,0,1-.662,2.473H21.677a4.949,4.949,0,0,1-.661-2.473V9.89A7.426,7.426,0,0,0,13.6,2.472Z",
    transform: "translate(1512.32 46.036)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M-1-.28V-2.593H4.1V-4.206H-2.655V1.439C-1.894,1.348-.4,1.287.281,1.287c1.461,0,2.358.669,2.358,1.765,0,1.187-.9,1.917-2.389,1.917A5,5,0,0,1-2.762,3.843L-3.492,5.3A7.6,7.6,0,0,0,.449,6.521c2.5,0,4.108-1.415,4.108-3.591C4.557,1.074,3.005-.3.586-.3.175-.3-.525-.3-1-.28Z",
    transform: "translate(1538.366 48.172)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.843fb1235e0472aefa2768a66f1b89f1.svg";
export { ForwardRef as ReactComponent };